import { observer } from 'mobx-react-lite';
import { HospitalQueueRowData } from '../../../socket/stream-types';
import { BaseQueueCell } from '../../../queues/components/base-queue-cell';
import { HospitalStatusTag } from '../../../common/components/hospital-status-tag';

export const HospitalQueueStatusCell = observer(function HospitalQueueStatusCell({
    data,
}: {
    data: HospitalQueueRowData;
}): React.ReactElement {
    return (
        <BaseQueueCell>
            <HospitalStatusTag
                hospitalStatus={data.hospitalStatus}
                hospitalStatusGlobalAttributeId={data.hospitalStatusGlobalAttributeId}
            />
        </BaseQueueCell>
    );
});
